import * as React from 'react';
import { Dropdown } from '@symphony-ui/uitoolkit-components';
import useOption from 'components/customHooks';
import PopupContext from 'contexts/PopupContext';
import GovernmentBondBenchmark from '../../../../../../models/data/GovernmentBondBenchmark';
const GovernmentBondBenchmarkEditor = ({ value, onChange }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [type, setType] = React.useState(value?.type);
    const options = useOption('/syndicate/overview/government-bond/options');
    const set = React.useCallback((newValue) => {
        onChange({ target: { value: newValue } });
    }, [onChange]);
    const onChangeType = React.useCallback((event) => {
        const newValue = event.target.value.value;
        const newBenchmark = new GovernmentBondBenchmark({ type: newValue });
        setType(newValue);
        set(newBenchmark);
    }, [set]);
    return (React.createElement(Dropdown, { onMenuClose: () => setBlockClose(false), onMenuOpen: () => setBlockClose(true), options: options, onChange: onChangeType, value: options.find(o => 'value' in o && o.value === type) }));
};
export default GovernmentBondBenchmarkEditor;
